import React from "react";
import {
  Container,
  Dropdown,
  Nav,
  Navbar,
  NavItem,
  NavLink,
} from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import { auth } from "../../../firebase.init";
import logo from "../../../img/logo.png";
import { signOut } from "firebase/auth";

const Header = () => {
  const [user] = useAuthState(auth);
  return (
    <Container fluid className="bg-success">
      <Container>
        <Navbar collapseOnSelect expand="lg" bg="success" variant="dark">
          <Container>
            <Navbar.Brand as={Link} to="/">
              <img
                style={{ width: "60px" }}
                className="rounded-circle bg-white"
                src={logo}
                alt="Agro log"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/">
                  Home
                </Nav.Link>

                
                <Nav.Link as={Link} to="/blog">Blog</Nav.Link>
              </Nav>
              {user && (
                <Nav className="me-auto">
                  <Nav.Link as={Link} to="/add-product">
                    Add Product
                  </Nav.Link>
                  <Nav.Link as={Link} to="/all-products">
                    All Product
                  </Nav.Link>
                  <Nav.Link as={Link} to="/my-item">
                    My Item
                  </Nav.Link>
                </Nav>
              )}
              <Nav className="me-left">
                {user ? (
                  <Dropdown className="text-white" as={NavItem}>
                    <Dropdown.Toggle as={NavLink}>
                      <svg
                        style={{ width: "40px", color: "#fff" }}
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => {
                        signOut(auth)
                      }}>
                        Log Out
                      </Dropdown.Item>
                      <span
                        className="bg-success d-block my-2 m-auto "
                        style={{ width: "95%", height: "2px" }}
                      ></span>
                      <Dropdown.Item disabled>Update Profile</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Nav.Link as={Link} to="/login">
                    Login
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Container>
    </Container>
  );
};

export default Header;
